import BigNumber from "bignumber.js";
import { calculateCostPrice } from "./productMapping";

export const isIncludedSelectedVariant = (variant: SelectedVariant, selectedVariants: SelectedVariant[]) => {
  return (
    selectedVariants.findIndex(
      selectedVariant =>
        selectedVariant.attribute_name === variant.attribute_name &&
        selectedVariant.attribute_value === variant.attribute_value
    ) !== -1
  );
};

export const isVariantSelected = (variant: any, selectedVariants: any[]) => {
  let isSelected = false;

  selectedVariants.forEach((item: any, idx) => {
    item.selectedVariants.forEach((selectedVariant: any) => {
      if (selectedVariant.attribute_value === variant.attribute_value) {
        isSelected = true;
      }
    });
  });

  return isSelected;
};

export const isSelectedVariant = (variant: SelectedVariant, selectedVariant: SelectedVariant) => {
  return (
    selectedVariant.attribute_name === variant.attribute_name &&
    selectedVariant.attribute_value === variant.attribute_value
  );
};

export const isVariantDefault = (attribute: ProductAttribute): boolean => {
  return !!(
    attribute.attribute_name === "default" &&
    attribute.is_required &&
    attribute.variants.length === 1 &&
    attribute.variants[0]?.attribute_value === "default"
  );
};

export const getVariantDefault = (product: Product): ProductVariation | undefined => {
  return product.attributes.find(attribute => isVariantDefault(attribute))?.variants[0];
};

export const getNormalAttributes = (
  { attributes }: { attributes: Product["attributes"] },
  markup: number
): ProductAttribute[] => {
  return attributes
    .filter(attribute => !isVariantDefault(attribute))
    .map(item => {
      return {
        ...item,
        variants: item.variants.map(item => {
          const costPrice = Number(item.price || 0) / (1 + markup / 100);
          const bigInt = new BigNumber(costPrice);

          return {
            ...item,
            price: Number(item.price).toFixed(2),
            // costPrice: bigInt.toFixed(2, BigNumber.ROUND_UP),
            costPrice: calculateCostPrice(item.price, markup),
          };
        }),
      };
    });
};
